import { render, staticRenderFns } from "./clashRelational.vue?vue&type=template&id=7c04db56&scoped=true"
import script from "./clashRelational.vue?vue&type=script&lang=js"
export * from "./clashRelational.vue?vue&type=script&lang=js"
import style0 from "./clashRelational.vue?vue&type=style&index=0&id=7c04db56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c04db56",
  null
  
)

export default component.exports